import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import CreateEventFormContainer from "../../components/Events/CreateEventFormContainer";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import { ToastMessage } from "../../components/ToastMessage";
import {
  createEvent,
  fetchEventDetails,
  updateEvent,
  uploadEventImage,
} from "../../services/eventsService";
import { validateCreateEvent } from "./validateCreateEvent";
import { toast } from "react-toastify";
import { getOutlet } from "../../services/outletService";
import {
  getFormatedEventResponse,
  getFormattedEventTime,
  getFormattedOutlets,
  getFormattedParks,
  getPromotionTime,
  getWeekArray,
} from "../../helper";
import { useLoadContext } from "../../contexts/LoadContext";
import { fetchAllActiveParks } from "../../services/parksService";
import { NEW_PARK_VISIT_TIME_INIT } from "../../config/Constants";

const CreateEvent = () => {
  const { id } = useParams();
  const [parks, setParks] = useState([]);
  const navigate = useNavigate();
  const [outlets, setOutlets] = useState([]);
  const [eventData, setEventData] = useState({
    title: "",
    description: "",
    location: "",
    // time: "",
    whatsapp: "",
    phone: "",
    imageUrl: "",
    date: "",
    endDate: "",
    // endTime: "",
    isInactive: "",
    deepLinkType: "events",
    deepLinkId: "",
  });
  const [error, setError] = useState({
    title: "",
    description: "",
    location: "",
    whatsapp: "",
    phone: "",
    imageUrl: "",
    date: "",
    endDate: "",
    isInactive: "",
    deepLinkType: "",
    deepLinkId: "",
    time: {},
    timeSingle: "",
    timeType: "",
  });
  const [uploadedImage, setUploadedImage] = useState();
  const [feedbackModal, setFeedbackModal] = useState({
    open: false,
    message: "",
    variant: "",
  });
  const [isNotificationEnabled, setIsNotificationEnabled] = useState(false);
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(false);
  const [notificationSent, setIsNotificationSent] = useState(false);
  const [disableSave, setDisableSave] = useState(false);
  const [time, setTime] = useState({
    type: "",
    timeMulti: { ...NEW_PARK_VISIT_TIME_INIT },
    timeSingle: { start: "", end: "" },
  });
  const { setLoader } = useLoadContext();

  useEffect(() => {
    fetchOutletList();
    fetchParks();
    if (id) {
      fetchEvent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchParks = async () => {
    try {
      let parks = await fetchAllActiveParks();
      let parkList = getFormattedParks(parks?.data?.data);
      parkList.push({
        label: "Select Park",
        value: "",
      });
      parkList.unshift(parkList.pop());
      setParks(parkList);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchOutletList = async () => {
    try {
      let { data } = await getOutlet();
      if (data.code === 200) {
        let formattedOutlets = getFormattedOutlets(
          data?.data,
          "Select Location",
        );
        setOutlets(formattedOutlets);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchEvent = async () => {
    try {
      let { data } = await fetchEventDetails(id);
      if (data.code === 200) {
        let formattedData = getFormatedEventResponse(data?.data);
        setEventData(formattedData);
        setTime(getFormattedEventTime(data?.data));
        setUploadedImage(formattedData.imageUrl);
        setIsNotificationEnabled(data.data.isNotificationEnabled);
        setIsCheckboxDisabled(
          data.data.isNotificationEnabled === true ? true : false,
        );
        setIsNotificationSent(
          data.data.isNotificationEnabled === true ? true : false,
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const uploadEvent = (event: any) => {
    let img = new Image();
    img.src = window.URL.createObjectURL(event.target.files[0]);
    img.onload = async () => {
      if (
        event.target.files[0].size > 2048756
        // ||
        // img.width > 1344 ||
        // img.height > 756
      ) {
        toast.error(
          <ToastMessage message="Only JPEG or PNG files are allowed. Max size: 2MB." />,
          {
            hideProgressBar: true,
          },
        );
      } else {
        try {
          let { data } = await uploadEventImage(event.target.files[0]);
          setUploadedImage(data.files[0]);
          let formData = { ...eventData };
          let formError = { ...error };
          //@ts-ignore
          formData["imageUrl"] = data.files[0].viewUrl;
          //@ts-ignore
          formError["imageUrl"] = "";
          setEventData(formData);
          setError(formError);
        } catch (error: any) {
          toast.error(<ToastMessage message="File cannot be uploaded." />, {
            hideProgressBar: true,
          });
        }
      }
    };
  };

  const handleChange = (event: any) => {
    let formData = { ...eventData };
    let formError = { ...error };
    if (event.target.name === "imageUrl") {
      uploadEvent(event);
    } else if (event.target.name === "deepLinkType") {
      formError["deepLinkId"] = "";
      formData["deepLinkId"] = "";
      //@ts-ignore
      formData[event.target.name] = event.target.value;
      //@ts-ignore
      formError[event.target.name] = "";
    } else if (event.target.name === "isInactive") {
      if (notificationSent) {
        setIsCheckboxDisabled(true);
        setIsNotificationEnabled(true);
      } else {
        if (event.target.value === "0") {
          setIsCheckboxDisabled(true);
          setIsNotificationEnabled(false);
        } else {
          setIsCheckboxDisabled(false);
        }
      }
      //@ts-ignore
      formData[event.target.name] = event.target.value;
      //@ts-ignore
      formError[event.target.name] = "";
    } else {
      //@ts-ignore
      formData[event.target.name] = event.target.value;
      //@ts-ignore
      formError[event.target.name] = "";
    }
    setEventData(formData);
    setError(formError);
  };

  const handleSubmit = () => {
    if (!validateCreateEvent(eventData,time, setError)) {
      setError({
        title: "",
        description: "",
        location: "",
        whatsapp: "",
        phone: "",
        imageUrl: "",
        date: "",
        endDate: "",
        isInactive: "",
        deepLinkType: "",
        deepLinkId: "",
        time: {},
        timeSingle: "",
        timeType: "",
      });
      if (id) {
        setDisableSave(true);
        editEventFlow();
      } else {
        setDisableSave(true);
        createEventFlow();
      }
    }
  };

  const editEventFlow = async () => {
    let postableData = { ...eventData };
    //@ts-ignore
    postableData.isInactive = postableData.isInactive === "1" ? false : true;
    //@ts-ignore
    postableData.isNotificationEnabled = isNotificationEnabled;

    // @ts-ignore
    postableData.isMultitime = time?.type === "single" ? false : true;

    if (time?.type === "single") {
      // @ts-ignore
      postableData.time = time.timeSingle.start;
      // @ts-ignore
      postableData.endTime = time.timeSingle.end;
    }
    if (time?.type === "multi") {
      // @ts-ignore
      postableData.multiTimings = getPromotionTime(
        time,
        getWeekArray(eventData?.date, eventData?.endDate),
      );
    }

    setLoader(true);
    try {
      let response = await updateEvent(postableData, id);
      //@ts-ignore
      if (response.status === 200) {
        setFeedbackModal({
          open: true,
          message: "Event updated successfully",
          variant: "success",
        });
      }
    } catch (err: { message: string } | any) {
      if (navigator.onLine) {
        setFeedbackModal({
          open: true,
          message: err?.message,
          variant: "error",
        });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          },
        );
      }
    } finally {
      setLoader(false);
    }
  };

  const createEventFlow = async () => {
    let postableData = { ...eventData };
    //@ts-ignore
    postableData.isInactive = postableData.isInactive === "1" ? false : true;
    //@ts-ignore
    postableData.isNotificationEnabled = isNotificationEnabled;

    // @ts-ignore
    postableData.isMultitime = time?.type === "single" ? false : true;

    if (time?.type === "single") {
      // @ts-ignore
      postableData.time = time.timeSingle.start;
      // @ts-ignore
      postableData.endTime = time.timeSingle.end;
    }
    if (time?.type === "multi") {
      // @ts-ignore
      postableData.multiTimings = getPromotionTime(
        time,
        getWeekArray(eventData?.date, eventData?.endDate),
      );
    }

    setLoader(true);
    try {
      let response = await createEvent(postableData);
      //@ts-ignore
      if (response.status === 200) {
        setLoader(false);
        setFeedbackModal({
          open: true,
          message: "Event created successfully",
          variant: "success",
        });
      }
    } catch (err: { message: string } | any) {
      setLoader(false);
      if (navigator.onLine) {
        setFeedbackModal({
          open: true,
          message: err?.message,
          variant: "error",
        });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          },
        );
      }
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleSubmitModal = () => {
    setFeedbackModal({
      open: false,
      message: "",
      variant: "",
    });
    if (feedbackModal.variant === "success") {
      navigate("/admin/events");
    }
  };

  const removeImage = () => {
    let formData = { ...eventData };
    let formError = { ...error };
    //@ts-ignore
    formData["imageUrl"] = "";
    //@ts-ignore
    formError["imageUrl"] = "";
    setEventData(formData);
    setError(formError);
    setUploadedImage(undefined);
  };

  const handleTimeSelect = (value: any, fromTo: any, name: any) => {
    if (name === "timeSingle") {
      let timeObj = { ...time.timeSingle };
      //@ts-ignore
      timeObj[fromTo] = value;
      setError({ ...error, timeSingle: "" });
      setTime({ ...time, timeSingle: { ...timeObj } });
    } else {
      let timeObj = { ...time.timeMulti };
      let err = { ...error };
      //@ts-ignore
      timeObj[name][fromTo] = value;
      //@ts-ignore
      err["time"][name] = "";
      setTime({ ...time, timeMulti: { ...timeObj } });
      setError(err);
    }
  };

  const handlePromoTimeTypeChange = (e: any) => {
    setTime({
      type: e.target.value,
      timeMulti: {
        mon: {
          start: "",
          end: "",
        },
        tue: {
          start: "",
          end: "",
        },
        wed: {
          start: "",
          end: "",
        },
        thu: {
          start: "",
          end: "",
        },
        fri: {
          start: "",
          end: "",
        },
        sat: {
          start: "",
          end: "",
        },
        sun: {
          start: "",
          end: "",
        },
      },
      timeSingle: { start: "", end: "" },
    });
    setError({ ...error, timeType: "", time: {}, timeSingle: "" });
  };

  return (
    <div>
      <CreateEventHeader>{id ? "Edit" : "Create"} Event</CreateEventHeader>
      <CreateEventFormContainer
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        onChange={handleChange}
        onRemove={removeImage}
        error={error}
        value={eventData}
        outlets={outlets}
        uploadedImage={uploadedImage}
        isNotificationEnabled={isNotificationEnabled}
        setIsNotificationEnabled={setIsNotificationEnabled}
        isCheckboxDisabled={isCheckboxDisabled}
        parks={parks}
        disabled={disableSave}
        onTimeSelect={handleTimeSelect}
        time={time.timeMulti}
        timeType={time.type}
        timeSingle={time.timeSingle}
        onPromoTimeChange={handlePromoTimeTypeChange}
      />
      {feedbackModal.open && (
        <ErrorSuccessModal
          //@ts-ignore
          variant={feedbackModal.variant}
          heading={feedbackModal.message}
          buttonLabel="Ok"
          onSubmit={handleSubmitModal}
        />
      )}
    </div>
  );
};

const CreateEventHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export default CreateEvent;
